<template functional>
  <div class="modal" :class="{ full: props.isFull }">
    <div class="modal-overlay" @click="listeners['close']" />
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header" :title="props.title" :listeners="listeners">
            <div class="modal-title">
              {{ props.title }}
            </div>
            <button
              aria-label="close"
              type="button"
              class="close-button"
              @click="listeners['close']"
            />
          </slot>
        </div>
        <div v-if="props.separator" class="modal-separator" />
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    /**
     * Modal title
     *
     * @type {string}
     */
    title: {
      type: String
    },
    /**
     * Display separator?
     *
     * @type {boolean}
     */
    separator: {
      type: Boolean,
      default: false
    },
    /**
     * Display Modal in full?
     *
     * @type {boolean}
     */
    isFull: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: $zindex-modal-backdrop;

  .modal-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.6;
    background-color: $black;
    z-index: $zindex-modal-backdrop;
  }

  .modal-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 10px;
    height: 100%;
  }

  .modal-content {
    position: relative;
    background-color: $white;
    background-clip: padding-box;
    outline: 0;
    pointer-events: auto;
    width: 100%;
    z-index: $zindex-modal;

    @include tablet {
      width: 600px;
    }
  }

  .modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 15px 15px 10px;

    .modal-title {
      font-weight: 700;
      font-size: 18px;
      width: 90%;
      text-align: left;
    }
  }

  .modal-separator {
    border-top: 1px solid $grey;
    margin: 5px 15px 20px;
  }

  .modal-body {
    position: relative;
    flex: 1 1 auto;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 15px;
  }

  .close-button {
    height: 35px;
    width: 35px;
    background-color: transparent;
    background-image: url('./assets/images/close-icon.svg');
    background-position: center;
    background-repeat: no-repeat;
    border: none;
    margin-top: -5px;
    margin-right: -10px;
  }

  &.full {
    .modal-dialog {
      margin: 0;
    }

    .modal-content {
      height: 100%;
    }

    .modal-body {
      // this height contains header and separator
      // for other usage of the modal, please overwrite the value accordingly
      height: calc(100vh - 81px);
      overflow: scroll;
    }
  }
}
</style>
